import { Box, LinearProgress, Paper, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import useStyles from "./styles";

import dayjs from "dayjs";
import LineChartComponent from "../../../../../components/lineComponent";
import { BarChartOutlined, SpeedOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";

const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

export default function GraficosResumo({
	errorPacketCount = {},
	networkSummary = {},
	loadingCharts = {},
	selectedInterface = [],
}) {
	// Estilização
	const theme = useTheme();
	const styles = useStyles(theme);

	const [windowWith, setWindowWith] = useState(window.innerWidth);

	const GRAPHS = [
		{
			title: "Tráfego de entrada",
			titleColor: theme.palette.cardGraphic.graphColor.blue,
			mainColor: theme.palette.cardGraphic.graphColor.blue,
			mainLineColor: theme.palette.cardGraphic.graphLineColor.blue,
			type: "in",
		},
		{
			title: "Tráfego de saída",
			titleColor: theme.palette.cardGraphic.graphColor.orange,
			mainColor: theme.palette.cardGraphic.graphColor.orange,
			mainLineColor: theme.palette.cardGraphic.graphLineColor.orange,
			type: "out",
		},
	];

	const getErrorCount = (type) => {
		if (!errorPacketCount || !errorPacketCount[type]) return 0;

		const errorData = errorPacketCount[type];
		const keys = Object.keys(errorData).filter((key) =>
			selectedInterface && selectedInterface.length > 0
				? selectedInterface.some((k) => key?.includes(k))
				: true,
		);

		return keys.reduce(
			(sum, key) => sum + Number(errorData[key]?.value || 0),
			0,
		);
	};

	const getNetworkSpeed = (type) => {
		if (!networkSummary || !networkSummary[`${type}Speed`]) return 0;

		const speedData = networkSummary[`${type}Speed`];
		const keys = Object.keys(speedData).filter((key) =>
			selectedInterface && selectedInterface.length > 0
				? selectedInterface.some((k) => key?.includes(k))
				: true,
		);

		return keys.reduce(
			(sum, key) => sum + Number(speedData[key]?.value || 0),
			0,
		);
	};

	useEffect(() => {
		const handleResize = () => {
			setWindowWith(window.innerWidth);
		};

		window.addEventListener("resize", handleResize);
	}, []);

	return (
		<Box sx={styles.container}>
			{GRAPHS?.map((graph) => {
				return (
					<Paper
						variant="outlined"
						sx={styles.paper}
						key={graph?.type}
						elevation={0}
					>
						{loadingCharts?.[graph?.type] && (
							<LinearProgress sx={styles?.linearProgress} />
						)}

						<Box sx={styles.boxChart}>
							<Box sx={styles.graphHeader}>
								<Typography
									sx={{ ...styles.cardSubText, color: graph?.titleColor }}
								>
									{graph?.title}
								</Typography>
								<Box sx={styles.containerChips}>
									<Box sx={styles.boxChipContente}>
										{windowWith > 500 && (
											<Box
												sx={{
													...styles.chipIconContainer,
													background:
														theme.palette.mode == "dark"
															? theme.palette.gradient.cardStatusDown
															: theme.palette.cardTrafficData.paperColor
																	.statusDown,
												}}
											>
												<BarChartOutlined sx={styles.chipIcon} />
											</Box>
										)}

										<Box sx={styles.boxChipText}>
											<Typography
												sx={styles.textChipTitle}
											>{`Erros: `}</Typography>
											<Typography
												color={theme.palette.colors.red.medium}
												sx={styles.textChipValue}
											>
												{`${getErrorCount(graph?.type)}`}
											</Typography>
										</Box>
									</Box>
									<Box sx={styles.boxChipContente}>
										{windowWith > 500 && (
											<Box sx={styles.chipIconContainer}>
												<SpeedOutlined sx={styles.chipIcon} />
											</Box>
										)}
										<Box sx={styles.boxChipText}>
											<Typography
												sx={styles.textChipTitle}
											>{`Velocidade: `}</Typography>
											<Typography
												color={
													theme.palette.mode == "dark"
														? theme.palette.cardTrafficData.iconColor.inputData
														: theme.palette.colors.blue.medium
												}
												sx={styles.textChipValue}
											>
												{`${formatBytes(getNetworkSpeed(graph?.type))}`}
											</Typography>
										</Box>
									</Box>
								</Box>
							</Box>

							<LineChartComponent
								mainColor={graph?.mainColor}
								mainLineColor={graph?.mainLineColor}
								maxTicks={10}
								maxValuebps={Math.max(
									...(networkSummary &&
									Array.isArray(networkSummary[graph?.type])
										? networkSummary[graph?.type].map((d) => d?.value || 0)
										: [0]),
								)}
								data={
									networkSummary && Array.isArray(networkSummary?.[graph?.type])
										? networkSummary?.[graph?.type]
										: []
								}
								stackedGraphKeys={selectedInterface || []}
							/>
						</Box>
					</Paper>
				);
			})}
		</Box>
	);
}

const formatBytes = (bytes) => {
	if (bytes == 0) return "0 B";
	const k = 1000;
	const sizes = ["bps", "Kbps", "Mbps", "Gbps", "Tbps", "Pbps", "Ebps"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
